import React, { useState, useEffect } from "react";
import { AccountSchema, LoginProps } from "../../../data/types";
import AuthCard from "../../../components/unauth/AuthCard";
import { PARTNER_LINKS } from "../../../components/unauth/partnerContent";


const EmailLogin: React.FC<LoginProps> = props => {  
    const [email, updateEmail] = useState('')
    let { 
        registerUser, 
        toggleSignUp,
    }: LoginProps = props

    const isValidEmail = (email: string): boolean => {
        const emailRegex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        return emailRegex.test(email)
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, field: string) => {
        if (field === 'email' && (e.target.value || e.target.value  === "")){
                e.preventDefault()
                updateEmail(e.target.value.toLowerCase())
            }
    }

    const goToOTP = async () => {
        if (email && registerUser !== undefined){
            var user_to_register: AccountSchema = {email}
            registerUser(user_to_register)
        }
    }

    useEffect(()=> {
        document.title = 'Partner Dashboard | Sign In'
     }, [])

    return (
        <AuthCard
            title="Sign in to your dashboard"
            subtitle="Use your partner account email and we'll send a one-time passcode."
            footNote={
                <>
                    {/* No passwords to manage.  */}
                    By continuing you agree to our{' '}
                    <a href={PARTNER_LINKS.terms} target="_blank" rel="noreferrer" className="font-semibold text-primary-100 hover:text-primary-300">
                        Terms of Service
                    </a>{' '}
                    and{' '}
                    <a href={PARTNER_LINKS.privacy} target="_blank" rel="noreferrer" className="font-semibold text-primary-100 hover:text-primary-300">
                        Privacy Policy
                    </a>
                    .
                </>
            }
        >
            <div className="flex flex-col gap-3">
                <input
                    placeholder="Email Address"
                    type="email"
                    value={email}
                    className="auth-input"
                    onChange={e => handleChange(e, 'email')}
                    onKeyDown={e => (e.key === 'Enter' && email) ? goToOTP() : null }
                />
                <button
                    className="auth-primary-btn"
                    disabled={!email || !isValidEmail(email)}
                    onClick={() => goToOTP()}
                >
                    Enter
                </button>
                <p className="text-center font-open-sans text-[13px] text-muted">
                    <span className="text-ink">New to HomeCook? </span>
                    <button
                        type="button"
                        className="border-0 bg-transparent p-0 font-open-sans text-[13px] font-semibold text-primary-300 hover:text-primary-100"
                        onClick={toggleSignUp}
                    >
                        Sign up as a partner
                    </button>
                </p>
            </div>
        </AuthCard>
    )
}






export default EmailLogin
